/**
 * Nuro AVP buttons — converts third-party variant option <select>
 * elements (rendered by the AVP / Advanced Variant Options app) into
 * pill-style radio buttons matching the Figma spec.
 *
 * Hides .ap-options__select-container > .avp-select and renders a
 * sibling .nuro-avp-btns group whose clicks sync the original select
 * (so the app's own logic still runs).
 *
 * Auto-applies on load and re-runs on DOM mutations in case the app
 * re-renders its options (variant change, AJAX cart, etc.).
 */
(function () {
  'use strict';

  var PROCESSED_ATTR = 'data-nuro-buttons-applied';

  function convertSelect(container) {
    if (container.hasAttribute(PROCESSED_ATTR)) return;

    var select = container.querySelector('select');
    if (!select || select.options.length === 0) return;

    var wrapper = container.querySelector('.avp-select');
    if (!wrapper) return;

    container.setAttribute(PROCESSED_ATTR, 'true');

    var group = document.createElement('div');
    group.className = 'nuro-avp-btns';
    group.setAttribute('role', 'radiogroup');

    Array.prototype.forEach.call(select.options, function (option) {
      // Skip empty placeholder when there are real options after it
      if (option.value === '' && select.options.length > 1) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nuro-avp-btn';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', option.selected ? 'true' : 'false');
      btn.dataset.value = option.value;
      btn.textContent = option.text;
      if (option.selected) btn.classList.add('is-selected');

      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        if (option.disabled) return;

        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        select.dispatchEvent(new Event('input', { bubbles: true }));

        group.querySelectorAll('.nuro-avp-btn').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-checked', 'true');
      });

      group.appendChild(btn);
    });

    // Hide the original select UI but keep the element accessible to the app
    wrapper.style.display = 'none';
    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.parentNode.insertBefore(group, wrapper);

    // Keep our buttons in sync if app changes the select programmatically
    select.addEventListener('change', function () {
      group.querySelectorAll('.nuro-avp-btn').forEach(function (b) {
        var match = b.dataset.value === select.value;
        b.classList.toggle('is-selected', match);
        b.setAttribute('aria-checked', match ? 'true' : 'false');
      });
    });
  }

  function scan(root) {
    var containers = (root || document).querySelectorAll(
      '.ap-options__select-container'
    );
    Array.prototype.forEach.call(containers, convertSelect);
  }

  function init() {
    // Run a few times because AVP often renders after document ready
    scan();
    setTimeout(scan, 400);
    setTimeout(scan, 1200);
    setTimeout(scan, 2500);

    // Watch for any later re-renders
    var target =
      document.querySelector('.product-info') ||
      document.querySelector('.js-product') ||
      document.body;

    if (target && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        scan(target);
      });
      observer.observe(target, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
